import type { FooterMenuStoryblok, RichtextStoryblok } from '#core/storyblok-component-types'

export const useFooterContent = () => useState<{
  default: FooterMenuStoryblok[]
  pro: FooterMenuStoryblok[]
  legalCopy: RichtextStoryblok
}>('footer')

export const useFooter = () => {
  const footerContent = useFooterContent()
  const footer = computed<FooterMenuStoryblok[]>(() => footerContent.value?.default ?? [])
  const proFooter = computed<FooterMenuStoryblok[]>(() => footerContent.value?.pro ?? [])
  const legalCopy = computed<RichtextStoryblok>(() => footerContent.value?.legalCopy)

  return {
    footer,
    proFooter,
    legalCopy,
  }
}
